import React from "react";
import {Button, Icon} from "peggirkit";
import {ArrowDownTrayIcon} from "@heroicons/react/16/solid";
import {useIntl} from "react-intl";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";
import {ExternalFile} from "@/data/entities/storage";
import {useMutation} from "@tanstack/react-query";
import {api} from "@/data/api";

type Props = {
    linkText: string,
    file: ExternalFile,
};

const ExternalStorageDownloadLink = ({linkText, file}: Props) => {
    const intl = useIntl();
    const {applyTooltip} = useTooltip();
    const {mutate: download, isPending} = useMutation({
        mutationFn: () => api.storage.getExternalFileDownloadUrl(file.id),
        onSuccess: ({downloadUrl}) => {
            window.location.href = downloadUrl;
        },
    });

    return (
        <Button
            variant={"link"}
            iconBefore={<Icon icon={ArrowDownTrayIcon}/>}
            props={{
                ...applyTooltip(intl.formatMessage(({id: "download"}))),
                "aria-label": intl.formatMessage(({id: "download"})),
            }}
            loading={isPending}
            buttonAction={{
                as: "button",
                actionProps: {
                    onClick: e => {
                        e.preventDefault();
                        download();
                    },
                },
            }}
        >
            {linkText}
        </Button>
    );
};

export default ExternalStorageDownloadLink;